@if (!windowService?.isDesktopRes) {
  <div class="floating-header" [class.has-left-content]="shouldShowAccountTypeSwitcher" [class.pointer-events-passthrough]="!shouldShowAccountTypeSwitcher">
    <div class="floating-header-left" [class.show-on-mobile]="shouldShowAccountTypeSwitcher">
      @if (shouldShowAccountTypeSwitcher) {
        <tidy-header-select
          [items]="accountTypeSelectItems"
          [(ngModel)]="accountTypeSelectValue"
          (optionChange)="onAccountTypeSelected($event)"
          [showIcons]="true"
          class="floating-select truncate-text" />
      }
      @if (selectedPropertyId === null && isAuthenticated && addresses?.length > 0) {
        <button class="icon-button add-property-button" (click)="goToAddProperty()">
          <span class="material-icons">add</span>
        </button>
      }
    </div>
    <div class="floating-header-right">
      <button class="icon-button search-button" (click)="goToNotificationCenter()">
        <div class="notification-wrapper">
          <span class="material-icons">notifications</span>
          @if (notificationCount > 0 && notificationCount < 10) {
            <div class="notification-badge">{{notificationCount}}</div>
          }
          @if (notificationCount >= 10) {
            <div class="notification-badge">9+</div>
          }
        </div>
      </button>
      <button class="icon-button search-button" (click)="goToSearchPage()">
        <span class="material-icons">search</span>
      </button>
    </div>
  </div>
}


@if (true) {
  <div class="map-background" [class.desktop-map]="windowService?.isDesktopRes" [class.mobile-map]="!windowService?.isDesktopRes" [class.dimmed]="propertyViewMode === 'floorplan' && selectedPropertyId !== null">
    @if (!isMapLoaded) {
      <ion-skeleton-text animated style="width: 100%; height: 100%; margin: 0;" />
    }
    <div [attr.id]="'map' + reportId" #map style="width: 100%; height: 100%;"></div>
  </div>

  @if (propertyViewMode === 'floorplan' && selectedPropertyId !== null && loaded) {
    <div class="floorplan-overlay">
      @defer {
        <tidy-floorplan-viewer
          [usdzUrl]="selectedAddress?.usdz_url"
          [isDemo]="!selectedAddress?.usdz_url"
          (createFloorplan)="createFloorplan()"
          (uploadFloorplan)="uploadFloorplan()"
          (zoomOutToMap)="onFloorplanZoomOut()" />
      } @loading {
        <div class="loading-overlay">
          <div class="loading-content">
            <div class="spinner"></div>
            <span class="loading-text">Loading 3D Viewer...</span>
          </div>
        </div>
      }
    </div>
  }
}

@if (shouldShowAccountTypeSwitcher && windowService?.isDesktopRes) {
  <div class="account-type-header" [class.dashboard-fade-in]="fadeInContent">
    <tidy-header-select
      [items]="accountTypeSelectItems"
      [(ngModel)]="accountTypeSelectValue"
      (optionChange)="onAccountTypeSelected($event)"
      [showIcons]="true"
      class="floating-select" />
  </div>
}

@if (shouldShowEmptyState) {
  <div class="floating-testimonial-card testimonial-1" [class.dashboard-fade-in]="fadeInContent">
    <div class="testimonial-content">
      <p class="testimonial-text">
        @if (isCompanyClient) {
          "{{ 'Our office has never looked better. TIDY keeps everything spotless.' | translate }}"
        } @else if (isRentalClient) {
          "{{ 'I never wanted to use a property manager because of the cost. TIDY saves me all the work at a fraction of the price.' | translate }}"
        } @else {
          "{{ 'I just tell TIDY what I need and it gets done. It\'s like magic.' | translate }}"
        }
      </p>
      <div class="testimonial-author">
        <div class="author-info">
          <span class="author-name">{{ isCompanyClient ? 'Lisa M.' : (isRentalClient ? 'Sarah M.' : 'Sarah K.') }}</span>
          @if (isRentalClient) {
            <span class="author-detail">Airbnb Host · 8 properties · Austin, TX</span>
          }
        </div>
        <span class="author-stars">★★★★★</span>
      </div>
    </div>
  </div>
  <div class="floating-testimonial-card testimonial-2" [class.dashboard-fade-in]="fadeInContent">
    <div class="testimonial-content">
      <p class="testimonial-text">
        @if (isCompanyClient) {
          "{{ 'Managing our office cleaning used to be a headache. Not anymore.' | translate }}"
        } @else if (isRentalClient) {
          "{{ 'I have 12 properties. I used to pick up the phone and play phone tag with 3 different people to come get turnovers done. It was a ton of work, but now I just use TIDY instead, it\'s way easier.' | translate }}"
        } @else {
          "{{ 'My home has never been this consistently clean. Worth every penny.' | translate }}"
        }
      </p>
      <div class="testimonial-author">
        <div class="author-info">
          <span class="author-name">{{ isCompanyClient ? 'James T.' : (isRentalClient ? 'Mark J.' : 'Michael T.') }}</span>
          @if (isRentalClient) {
            <span class="author-detail">Property Manager</span>
          }
        </div>
        <span class="author-stars">★★★★★</span>
      </div>
    </div>
  </div>
  <div class="floating-testimonial-card testimonial-3" [class.dashboard-fade-in]="fadeInContent">
    <div class="testimonial-content">
      <p class="testimonial-text">
        @if (isCompanyClient) {
          "{{ 'Our employees love coming to a clean workspace every day.' | translate }}"
        } @else if (isRentalClient) {
          "{{ 'TIDY is the easiest system I have ever worked with. Adding photos to my cleanings made a huge difference in making sure cleaners set up my Airbnb the way I want for my guests. Just fantastic!' | translate }}"
        } @else {
          "{{ 'TIDY exceeded my expectations. Highly recommend!' | translate }}"
        }
      </p>
      <div class="testimonial-author">
        <div class="author-info">
          <span class="author-name">{{ isCompanyClient ? 'Rachel K.' : (isRentalClient ? 'Margaret Z.' : 'Amanda L.') }}</span>
          @if (isRentalClient) {
            <span class="author-detail">Airbnb Host</span>
          }
        </div>
        <span class="author-stars">★★★★★</span>
      </div>
    </div>
  </div>
  <div class="no-properties-overlay" [class.dashboard-fade-in]="fadeInContent">
    <div class="empty-state-center">
      <tidy-row class="extra-bottom-padding">
        <tidy-text [largeTitle]="'Add a Property'" />
      </tidy-row>
      <tidy-row>
        <form [formGroup]="addPropertyForm">
          <tidy-auto-complete
            #addressAutoComplete
            label="Address"
            formControlName="address"
            [options]="addressSuggestions"
            [icon]="'assets/svg/home.svg'"
            [form]="addPropertyForm.controls.address"
            [errorMessage]="'Please enter a valid address'"
            (keyup)="onAddressSearch()"
            (action)="selectAddressSuggestion($event)" />
          </form>
      </tidy-row>
      @if (addressConfirmed) {
        <tidy-row>
          <div class="detected-location">
            <span class="material-icons">place</span>
            <span class="location-text">{{ detectedLocationSummary }}</span>
            <span class="material-icons check">check_circle</span>
          </div>
        </tidy-row>
        @if (needsZipcode) {
          <tidy-row>
            <form [formGroup]="addPropertyForm">
              <tidy-input
                formControlName="zipcode"
                [form]="addPropertyForm.controls.zipcode"
                [customMask]="zipcodeMask"
                [label]="zipcodeLabel"
                [errorMessage]="'Please enter a valid zipcode'"
                [submitted]="addPropertySubmitted"
                [icon]="'assets/img/mailbox.svg'" />
            </form>
          </tidy-row>
        }
        <tidy-row>
          <form [formGroup]="addPropertyForm">
            <tidy-input
              formControlName="address2"
              [form]="addPropertyForm.controls.address2"
              [label]="'Unit / Apt (optional)'"
              [icon]="'assets/img/door.svg'" />
          </form>
        </tidy-row>
        <tidy-row>
          <form [formGroup]="addPropertyForm">
            <tidy-input
              formControlName="addressNickname"
              [form]="addPropertyForm.controls.addressNickname"
              [label]="'Nickname (optional)'"
              [icon]="'assets/svg/information-circle.svg'" />
          </form>
        </tidy-row>
        }
        @if (addPropertyError) {
          <div class="form-error">{{ addPropertyError | translate }}</div>
        }
      <tidy-button
        [text]="'Add Property'"
        class="primary full-width"
        [disabled]="!addressConfirmed || isAddingProperty"
        [action]="submitAddProperty.bind(this)" />
      @if (isRentalClient) {
        <tidy-button
          [text]="'Import from Integration'"
          [image]="'assets/svg/sync-outline.svg'"
          class="secondary full-width"
          [action]="goToIntegrationInline.bind(this)" />
      }
    </div>
    <div class="testimonials-carousel">
      <div class="carousel-track">
        <div class="carousel-card">
          <p class="testimonial-text">
            @if (isCompanyClient) {
              "{{ 'Our office has never looked better. TIDY keeps everything spotless.' | translate }}"
            } @else if (isRentalClient) {
              "{{ 'I never wanted to use a property manager because of the cost. TIDY saves me all the work at a fraction of the price.' | translate }}"
            } @else {
              "{{ 'I just tell TIDY what I need and it gets done. It\'s like magic.' | translate }}"
            }
          </p>
          <div class="testimonial-author">
            <div class="author-info">
              <span class="author-name">{{ isCompanyClient ? 'Lisa M.' : (isRentalClient ? 'Sarah M.' : 'Sarah K.') }}</span>
              @if (isRentalClient) {
                <span class="author-detail">Airbnb Host · 8 properties · Austin, TX</span>
              }
            </div>
            <span class="author-stars">★★★★★</span>
          </div>
        </div>
        <div class="carousel-card">
          <p class="testimonial-text">
            @if (isCompanyClient) {
              "{{ 'Managing our office cleaning used to be a headache. Not anymore.' | translate }}"
            } @else if (isRentalClient) {
              "{{ 'I have 12 properties. I used to pick up the phone and play phone tag with 3 different people to come get turnovers done. It was a ton of work, but now I just use TIDY instead, it\'s way easier.' | translate }}"
            } @else {
              "{{ 'My home has never been this consistently clean. Worth every penny.' | translate }}"
            }
          </p>
          <div class="testimonial-author">
            <div class="author-info">
              <span class="author-name">{{ isCompanyClient ? 'James T.' : (isRentalClient ? 'Mark J.' : 'Michael T.') }}</span>
              @if (isRentalClient) {
                <span class="author-detail">Property Manager</span>
              }
            </div>
            <span class="author-stars">★★★★★</span>
          </div>
        </div>
        <div class="carousel-card">
          <p class="testimonial-text">
            @if (isCompanyClient) {
              "{{ 'Our employees love coming to a clean workspace every day.' | translate }}"
            } @else if (isRentalClient) {
              "{{ 'TIDY is the easiest system I have ever worked with. Adding photos to my cleanings made a huge difference in making sure cleaners set up my Airbnb the way I want for my guests. Just fantastic!' | translate }}"
            } @else {
              "{{ 'TIDY exceeded my expectations. Highly recommend!' | translate }}"
            }
          </p>
          <div class="testimonial-author">
            <div class="author-info">
              <span class="author-name">{{ isCompanyClient ? 'Rachel K.' : (isRentalClient ? 'Margaret Z.' : 'Amanda L.') }}</span>
              @if (isRentalClient) {
                <span class="author-detail">Airbnb Host</span>
              }
            </div>
            <span class="author-stars">★★★★★</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="trust-strip" [class.dashboard-fade-in]="fadeInContent">
    <div class="trust-strip-inner">
      <div class="trust-item trust-google">
        <img src="assets/img/google.svg" alt="Google" class="trust-logo" />
        <div class="trust-rating">
          <span class="rating-value">4.7</span>
          <span class="rating-stars">★★★★★</span>
        </div>
      </div>
      <div class="trust-divider"></div>
      @if (isCompanyClient) {
        <div class="trust-item trust-stat">
          <span class="stat-value">100K+</span>
          <span class="stat-label">{{ 'happy customers' | translate }}</span>
        </div>
        <div class="trust-divider"></div>
        <div class="trust-item trust-stat">
          <span class="stat-value">11</span>
          <span class="stat-label">{{ 'years in business' | translate }}</span>
        </div>
      } @else if (isRentalClient) {
        <div class="trust-item trust-stat">
          <span class="stat-value">10K+</span>
          <span class="stat-label">{{ 'property managers' | translate }}</span>
        </div>
        <div class="trust-divider"></div>
        <div class="trust-item trust-logos-carousel">
          <span class="logos-label">{{ 'Trusted by' | translate }}</span>
          <div class="logos-track">
            <div class="logos-scroll">
              <img src="assets/img/customerlogos/arklogo.png" alt="Ark" class="customer-logo" />
              <img src="assets/img/customerlogos/zeus.svg" alt="Zeus" class="customer-logo" />
              <img src="assets/img/customerlogos/compass.svg" alt="Compass" class="customer-logo" />
              <img src="assets/img/customerlogos/darker.png" alt="Darker" class="customer-logo" />
              <img src="assets/img/customerlogos/luxurylifestyle.png" alt="Luxury Lifestyle" class="customer-logo" />
              <img src="assets/img/customerlogos/stroyke.png" alt="Stroyke" class="customer-logo" />
              <img src="assets/img/customerlogos/kuhr.png" alt="Kuhr" class="customer-logo" />
              <img src="assets/img/customerlogos/boutiq.png" alt="Boutiq" class="customer-logo" />
              <img src="assets/img/customerlogos/hemlane.svg" alt="Hemlane" class="customer-logo" />
              <img src="assets/img/customerlogos/amenify.svg" alt="Amenify" class="customer-logo" />
              <img src="assets/img/customerlogos/arklogo.png" alt="Ark" class="customer-logo" />
              <img src="assets/img/customerlogos/zeus.svg" alt="Zeus" class="customer-logo" />
              <img src="assets/img/customerlogos/compass.svg" alt="Compass" class="customer-logo" />
              <img src="assets/img/customerlogos/darker.png" alt="Darker" class="customer-logo" />
              <img src="assets/img/customerlogos/luxurylifestyle.png" alt="Luxury Lifestyle" class="customer-logo" />
              <img src="assets/img/customerlogos/stroyke.png" alt="Stroyke" class="customer-logo" />
              <img src="assets/img/customerlogos/kuhr.png" alt="Kuhr" class="customer-logo" />
              <img src="assets/img/customerlogos/boutiq.png" alt="Boutiq" class="customer-logo" />
              <img src="assets/img/customerlogos/hemlane.svg" alt="Hemlane" class="customer-logo" />
              <img src="assets/img/customerlogos/amenify.svg" alt="Amenify" class="customer-logo" />
            </div>
          </div>
        </div>
      } @else {
        <div class="trust-item trust-stat">
          <span class="stat-value">100K+</span>
          <span class="stat-label">{{ 'happy customers' | translate }}</span>
        </div>
        <div class="trust-divider"></div>
        <div class="trust-item trust-stat">
          <span class="stat-value">11</span>
          <span class="stat-label">{{ 'years in business' | translate }}</span>
        </div>
      }
    </div>
  </div>
}

@if (addresses?.length > 0 && isAuthenticated) {
  <pulse-timeline
    (goToEditPropertyPageClicked)="goToEditPropertyPage()"
    [events]="pulseEvents"
    [propertyName]="selectedPropertyName"
    [propertyInfo]="propertyInfo"
    [propertyItems]="propertyItems"
    [forceEmptyState]="showEmptyTimeline"
    [isConsumer]="!isRentalClient"
    [selectedPropertyId]="selectedPropertyId"
    [propertyData]="propertyData"
    [locationData]="locationData"
    [propertyCodesData]="propertyCodesData"
    [isLoadingPropertyData]="isLoadingPropertyData"
    [isLoadingLocationData]="isLoadingLocationData"
    [isLoadingPropertyCodes]="isLoadingPropertyCodes"
    [isLoadingPropertySummary]="isLoadingPropertySummary && !routeReused"
    [isTimelineLoaded]="isTimelineDataLoaded"
    [isLocationExpanded]="isPropertyInfoExpanded"
    [viewModeItems]="viewModeItems"
    [propertyViewMode]="propertyViewMode"
    (viewModeChanged)="selectViewMode($event)"
    (nameChanged)="onPropertyNameChanged($event)"
    (accessNotesChanged)="onAccessNotesChanged($event)"
    (customFieldsChanged)="onCustomFieldsChanged($event)"
    (propertyDataChanged)="onPropertyDataChanged($event)"
    (fieldClicked)="onPropertyFieldClicked($event)"
    (addJobClicked)="onAddJob()"
    (bookJobClicked)="onBookJob()"
    (setupSmartSuggestionsClicked)="onSetupSmartSuggestions()"
    (toggleLocationExpand)="isPropertyInfoExpanded = !isPropertyInfoExpanded"
    (locationIconClicked)="onInfoIconClicked($event)"
    (quickActionClicked)="onQuickAction($event)"
    (propertySelected)="selectProperty($event)"
    (addPropertyClicked)="toggleAddPropertyPopup()"
    [isGuestAccount]="isGuestAccount"
    [isRentalClient]="isRentalClient"
    (signInClicked)="goToSignIn()" />
}

<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Overview'"
      [showLinkIcon]="true"
      [linkIcon]="'notification'"
      (linkAction)="goToNotificationCenter()" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav; context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [hasBottomNav]="true" [ngClass]="{'floating-panel': windowService?.isDesktopRes}" [ngStyle]="!windowService?.isDesktopRes ? {'margin-top': '420px', 'position': 'relative', 'z-index': '10', 'padding-bottom': '80px'} : {}">

    @if (!windowService?.isDesktopRes && !isAuthenticated) {
      <div class="floating-header secondary-floating-header">
          <div class="floating-header-left">
            <button class="icon-button" (click)="goToSearchPage()">
              <span class="material-icons">search</span>
            </button>
          </div>

          <div class="floating-header-center">
            @if (selectedPropertyId === null && !isAuthenticated) {
              <tidy-dropdown-menu
                [triggerText]="selectedPropertyName || ('All Properties' | translate)"
                [items]="propertyItems"
                [selectedValue]="selectedPropertyId"
                (selectItem$)="selectProperty($event)">
                <ng-container footer>
                  <button class="dropdown-item add-property" (click)="goToAddProperty()">
                    <span class="material-icons">add</span>
                    <span>{{ 'Add Property' | translate }}</span>
                  </button>
                </ng-container>
              </tidy-dropdown-menu>
            }
          </div>

          <div class="floating-header-right">
            <button class="icon-button" (click)="goToNotificationCenter()">
              <span class="material-icons">inbox</span>
            </button>
          </div>
        </div>

      @if (loaded) {
        <div class="map-background mobile-map">
          @if (!isMapLoaded) {
            <ion-skeleton-text animated style="width: 100%; height: 100%; margin: 0;" />
          }
          <div [attr.id]="'map' + reportId" #map style="width: 100%; height: 100%;"></div>
        </div>
      }

    }

  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [isfullWidthContent]="true" [templateContent]="content" [desktopWidthContent]="desktopWidthContent" />


<tidy-bottom-nav [activeRoute]="dashboardPath" />
